import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorB3ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorB3ByHealthTeamData {
	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	totalProcedures: number = 0;
	totalProceduresLinked: number = 0;
	totalToothExtractionProcedures: number = 0;
	totalToothExtractionProceduresLinked: number = 0;
}

export async function getResumeIndicatorB3ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorB3ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorB3ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b3/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorB3ByHealthTeamData>();
}
